/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getPath } from '@express-labs/raven-tools';
import { HeaderContext } from '../../../../../contexts/HeaderData/HeaderData';
import DesktopNavigation from './DesktopNavigation';

function DesktopNavigationVM({ hideTopHeader, topPosition }) {
  const dataContext = useContext(HeaderContext);
  const data = getPath(dataContext, 'data', {});
  const stickyHeaderLimited = !!window?.FLAGS?.StickyHeaderLimited;

  return (
    <DesktopNavigation
      navData={data}
      stickyHeaderLimited={stickyHeaderLimited}
      hideTopHeader={hideTopHeader}
      topPosition={topPosition}
    />
  );
}

DesktopNavigationVM.propTypes = {
  hideTopHeader: PropTypes.bool.isRequired,
  topPosition: PropTypes.number,
};

export default DesktopNavigationVM;
